<template>
	<v-sheet color="transparent" class="pa-2" v-if="settings">
		<v-text-field v-model="settings.title">Assessment Title</v-text-field>
		<h4 class="grey--text cn-font mb-4">Parts</h4>
		<PartForm v-for="(part, i) in settings.parts" :key="i" :part="part"></PartForm>

		<p class="text-right">			
			<v-dialog v-model="part_dialog" width="500">
				<template v-slot:activator="{ on }">
					<v-btn color="accent" small fab dark v-on="on" ><v-icon>mdi-plus</v-icon></v-btn>
				</template>
				<NewAssessmentPart @close="part_dialog = false"></NewAssessmentPart>
			</v-dialog>
		</p>
		<p class="text-right">
			<SaveSavingSaved @save="save" :status="status"></SaveSavingSaved>
		</p>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import NewAssessmentPart from "@/components/admin/forms/NewAssessmentPart"
	import SaveSavingSaved from "@/components/elements/SaveSavingSaved"
	import PartForm from "@/components/admin/forms/PartForm"

	export default {
		name: "AssessmentSettings", 
		props: {
			
		},
		data: () => {
			return {
				active: false,
				part_dialog: false, 
				new_section_dialog: false, 
				status: null
			}
		},
		components: {
			NewAssessmentPart,
			PartForm,
			SaveSavingSaved
		},
		computed: {
			...Vuex.mapState({
				surveys: state => state.surveys,
				settings: state => state.assessmentSettings || false
			}),
		},
		methods: {
			move( part, direction ){
				this.$store.dispatch("assessmentSettings/movePart", {id: part.id, direction: direction});
			},

			save(){
				const self = this;
				self.status = "unsaved"
				self.$store.dispatch("assessmentSettings/save" ).then( () => {
					self.status = "saved";
				})

			}
		},
		watch: {
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					this.status = "unsaved";
					if( newValue && !oldValue ){					
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("surveys/getAll")
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
					}
					
				}
			}
		}

	}
</script>